InlineConfirm = LP.module 'InlineConfirm'

InlineConfirm.data_confirm = ($element) ->
    defaults =
      title: $element.attr('title') || 'Confirm',
      message: $element.data('confirm') || 'Are you sure?',
      confirm_button_text: 'Ok',
      method: $element.data('method') || 'get',
      remote: $element.data('remote') || false,
      datatype: $element.data('type') || null,
      href: $element.attr('href'),
      container: $element.data('container') || 'body',
      klasses: $element.data('klasses') || ''

    cssAffectedAttributes = ['overflow-y', 'padding-right']
    defaults.containerStyle = $(defaults.container).css cssAffectedAttributes
    options = $.extend defaults, $element.data('inpage-confirm')

    html = """
            <div id="inpage-confirm" class="row vertical-align">
              <div class="col-xs-10 col-xs-offset-1">
                <div class="modal-header">
                  <h3>#{options.title}</h3>
                </div>
                <div class="modal-body">
                  <p>#{options.message}</p>
                </div>
                <div class="modal-footer">
                  <a class="btn btn-primary confirm #{options.klasses}">#{options.confirm_button_text}</a>
                  <a class="btn btn-default js-close">Cancel</a>
                </div>
              </div>
            </div>
           """

    handleClose = ($element, options) ->
      if LP.config.isDesktop
        # revert the style changes on the container element after animation
        $element.animate width: 'hide', 120, ->
          $(options.container).css options.containerStyle
          $element.remove()
      else
        $element.remove()

    # Create the content DOM element with the parent's dimensions
    $html = $(html).css(
      width: '100%',
      left: 15,
      top: $(options.container).scrollTop()
    )

    # compensate for the scroll bar width
    scrollBarWidth = $(options.container).outerWidth() - $(options.container)[0].scrollWidth
    padding = parseInt($(options.container).css('padding-right')) + scrollBarWidth
    defaultAttrs = overflow: 'hidden', paddingRight: padding
    $(options.container).css(defaultAttrs).append($html)

    $confirm_button = $('.confirm', $html).attr
      'data-method': options.method
      'href': options.href
      'data-remote': if options.remote then true else null
      'data-type': if options.datatype then options.datatype else null

    $('.js-close', $html).on 'click', -> handleClose $html, options

    if LP.config.isDesktop
      # animation - slide from left to right
      $html.css(display: 'none').animate { width: 'show' },
        duration: 250,
        step: ->
          # close all tooltips because they have a greater z-index
          $('.tooltip.in').tooltip('hide')

    # Close right edit page panel when opening the delete item confirmation
    if $element.is('.delete', '.collection-action-item-content')
      window.editPageContextHack.manageContentArea()

    # display the html and fire an event
    $element.trigger 'inpage-confirm:display', [$html]

    # if the confirmation link is remote we'll fire some events on error and success
    $confirm_button.on 'ajax:success:display', (e, messages, $messages)->
      handleClose $html, options
      $element.trigger 'inpage-confirm:success', [messages, $messages]

    $confirm_button.on 'ajax:error:display', (e, errors, $errors) ->
      $default_msg = $('<span class="text-danger">Something went wrong, please reload the page.</span>')
      $('.modal-body', $html).html($errors || $default_msg)
      $element.trigger 'inpage-confirm:error', [errors, $errors]

    # Tablets trigger both AJAX & HTML calls to href.
    $confirm_button.on 'click', (e) ->
      e.preventDefault()

    # submit the form on click of the confirm button
    if $element.is(':submit')
      $confirm_button.on 'click', (e) ->
        e.stopPropagation()
        $element.closest('form').submit()
        handleClose $html, options
